<template lang="">
	<div>
		<c-r-m-nav-cell
			ref="navcell" 
			:crm-type="crmType" 
			route-type="read"
			@on-handle="listHeadHandle"/>
		<div class="detailtop">
			<div style="margin-top: 10px; display: flex;">
				<!-- 左边 -->
				<div class="left-box">
					<div class="bianji">编辑详情</div>
					<div 
						class="left-item" 
						v-for="(item,index) in leftList"
						:key="index"
						@click="onLeftHandle(item)">
						<span>{{item.name}}</span>
						<i class=" el-icon-arrow-right"></i>
					</div>
				</div>
				
				<!-- 右边 -->
				<div class="right-box">
					<c-r-m-base-info 
						ref="baseinfo"
						v-if="tabCurrentName == 'basicinfo'" 
						:crmType="crmType"/>
					<!-- <c-r-m-customer-log 
						v-if="tabCurrentName == 'record'" 
						:crmType="crmType"
						:id="id"/> -->
					<c-r-m-customer-tocase 
						v-if="tabCurrentName == 'tolawcase'" 
						:crmType="crmType"
						:id="id"/>
					<c-r-m-action-record
						v-if="tabCurrentName == 'action'" 
						:crmType="crmType"
						:id="id"/>
				</div>
			</div>
		</div>
		<!-- 员工 -->
		<relate-empoyee 
			:visible.sync="transferDialogShow" 
			:type="type"
			:radio="radio"
			title="请选择员工"
			@save="employeesSave" />
			
		<!-- dialog弹窗 -->
		<dialog-form
			:dialog-visible="dialogForm"
			:title="title"
			ref="crmform"  
			:crm-type="crmType"
			:fields-data = "fieldsData"
			:action="action"
			:form-data="formData"
			@close = "closeDialog"
			@save-dialog="saveDialog">
		</dialog-form>
	</div>
</template>
<script>
	import moment from 'moment'
	import { mapGetters } from 'vuex'
	import CRMNavCell from '@/components/table/new/CRMNavCell'
	import CRMBaseInfo from '@/components/table/new/customer/CRMCutomerBaseInfo'
	// import CRMCustomerLog from '@/components/table/new/customer/CRMCustomerLog'
	import CRMCustomerTocase from '@/components/table/new/customer/CRMCustomerTocase'
	import CRMActionRecord from '@/components/table/new/CRMActionRecord'
	// 员工组件
	import RelateEmpoyee from '@/views/setting/auth/components/relateEmpoyee'
	import {DialogForm} from '@/components/FromData'
	import {
		crmContactsSave,
		crmCustomerTeamSave,
		crmCustomerTransfer,
		crmCustomerNochargeSave,
		crmCustomerThrow,
		crmCustomerFocus
	} from '@/api/customer/customer'
	export default {
		name: "app",
		components: {
			CRMNavCell,
			CRMBaseInfo,
			// CRMCustomerLog,
			CRMCustomerTocase,
			CRMActionRecord,
			RelateEmpoyee,
			DialogForm
		},
		computed: {
			...mapGetters(['allAuth'])
		},
		data() {
			return {
				crmType:"customer",
				tabCurrentName: 'basicinfo',
				
				// 基本信息
				loading:false,
				list: [],
				id:0,
				
				// 左侧操作按钮
				leftList:[
					{ "name":"转移客户" , "type":"alloc" },
					{ "name":"分享客户" , "type":"save_team" },
					{ "name":"添加联系人" , "type":"save_contacts" },
					{ "name":"放入公海池" , "type":"put_pool" },
					// { "name":"关注客户" , "type":"focus" },
				],
				
				// 员工
				transferDialogShow:false,
				type:'',
				radio:true,
				
				// dialog弹窗
				dialogForm:false,
				title:"",
				dialogType:"",
				fieldsData:[],
				action:{ type: 'save',relevant:'company' },
				formData:{},
				detailData:{},
			}
		},
		mounted() {
			this.tabCurrentName = this.$route.params.tabname
			this.id = this.$route.params.id
			this.getbadgeNum()
		},
		methods: {
			//* * tab标签点击 */
			listHeadHandle(tabName) {
				this.tabCurrentName = tabName
				this.$router.push({
					path:"/customer/read/"+tabName+"/"+this.$route.params.id
				}) 
				this.id = this.$route.params.id
			},
			
			// 获取角标
			getbadgeNum(){
				this.$store.commit('emptybadge')
				this.$store.dispatch('GetCustomerBadgeNum', this.id)
			},
			
			onLeftHandle(item){
				switch (item.type){
					case "alloc":
					case "save_team":
						this.transferDialogShow = true
						this.type = item.type
						break;
					
					case "save_contacts":
						this.title = "新增联系人信息"
						this.dialogForm = true
						this.action = { type: 'save',relevant:'contacts',actiontype:14}
						break;
						
					case "put_pool":
						this.delInfo({"type":item.type})
						break;
						
					case "focus":
						this.delInfo({"type":item.type})
						break;
				}
			},
			
			
			/**
			 * 员工
			 */
			employeesSave(val) {
				if(!val.type) return
				let request
				let owner_user_id
				if (val.type == 'save_team') {
					request = crmCustomerTeamSave
					owner_user_id = val.users[0].id
				}else if (val.type == 'alloc') {
					request = crmCustomerTransfer
					owner_user_id = val.users[0].id
				}
				
				request({
						id: this.$route.params.id,
						owner_user_id: owner_user_id
					})
					.then(res => {
						this.$message.success(res.data)
						this.transferDialogShow = false
						this.$refs.baseinfo.getBaseInfo()
					})
					.catch(() => {})
				
			},
			
			// 弹窗操作
			closeDialog(){
				this.title = ""
				this.dialogForm = false
				this.formData = {}
			},
			
			// 保存操作
			saveDialog(item){
				let data = item.data
				data["customer_id"] = this.$route.params.id
				let request
				if(item.type == "save_contacts"){
					request = crmContactsSave
				}
				
				request(data)
					.then(res => {
						this.$message.success(res.data)
						this.closeDialog()
						this.$refs.baseinfo.getBaseInfo()
						this.$refs.baseinfo.getDetial()
					})
			},
			
			
			delInfo(item){
				let request
				let id
				if(item.type == "put_pool"){
					request = crmCustomerThrow
					id = this.$route.params.id
				}else if(item.type == "focus"){
					request = crmCustomerFocus
					id = this.$route.params.id
				}
				this.$confirm('确定进行此操作?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
				.then(() => {
					request({
						id:id
					})
					.then(res => {
						this.$message.success(res.data)
						this.$refs.baseinfo.getBaseInfo()
					})
					.catch(() => {})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消操作'
					})
				})
			}
		}
	};
</script>
<style scoped>
	.detailtop{
		display: flex;
		background-color: #f2f2f2; 
		align-items: center; 
		flex-direction: column; 
		min-height: 100vh;
	}
	.content_item {
		height: 100%;
		display: flex;
		align-items: center;
		font-size: 12px;
	}

	.content_box {
		height: 40px;
		/* background-color: #eeeff4; */
		display: flex;
		align-items: center;
		padding: 0 10px;
	}

	.titel_item {
		height: 100%;
		display: flex;
		align-items: center;
		font-size: 14px;
		font-weight: 550;
	}

	.titel_box {
		height: 50px;
		background-color: #eeeff4;
		display: flex;
		align-items: center;
		padding: 0 10px;
	}

	.lianxiren_add {
		margin: 0 5px;
		color: #fff;
		background-color: #F56C6C;
		font-size: 12px;
		padding: 5px 10px;
	}

	.lianxirem_title {
		height: 100%;
		display: flex;
		align-items: center;
		font-size: 18px;
		font-weight: 600;
	}

	.lianxiren {
		height: 50px;
		align-items: center;
		/* border-bottom: 1px solid #f2f2f2; */
		display: flex;
		justify-content: space-between;
		background-color: #fff;
		margin-top: 20px;
		padding: 0 10px;
	}

	

	.left-item {
		border-radius: 3px;
		border: 1px solid #f2f2f2;
		margin: 3px 5px;
		font-size: 13px;
		padding: 10px 15px;
		display: flex;
		justify-content: space-between;
		color: #8d8d8d;
		cursor: pointer;
	}
	.left-item:hover{
		background-color: #F56C6C;
		color: #fff;
	}

	.box {
		width: 1200px;
	}

	
	/* /deep/ .el-tabs__item.is-top:last-child{
		padding-right: 20px !important;
	}
	/depp/ .el-tabs--top .el-tabs__item.is-top:nth-child(2){
		padding-left: 20px !important;
	} */

	.nav_item {
		color: #545454;
		font-weight: 600;
	}

	.left-box {
		width: 200px;
		/* height: 740px; */
		background-color: #fff;
		padding: 5px;
		display: flex;
		flex-direction: column;
	}

	.right-box {
		width: 1340px;
		margin-left: 10px;
		background-color: #fff;
	}
	.bianji{
		display: flex;
		justify-content: center;
		align-items: center;
		height: 50px;
		font-weight: 600;
		font-size: 14px;
	}
</style>